// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__17tYq","checkboxCol":"Table_checkboxCol__2G7h2","emailCol":"Table_emailCol__3hPZU","actionCol":"Table_actionCol__1KS71"};